
























































import UserRequired from "../UserRequired";
import {Component, Inject} from "vue-property-decorator";
import Api from "./Api";
import {companyroleid, MonthCountStat} from "@/modules/models";
import MonthlyCount from "@/components/super/MonthlyCount.vue";
import Routes from "@/modules/Routes";
import CompanyUserRequired from "@/components/CompanyRequired";

@Component({
    components: {
        "at-monthlycount": MonthlyCount,
    }
})
export default class SuperUsageStats extends CompanyUserRequired {
    @Inject()
    api!: Api;

    loading = false;

    showExpanded = false;
    terminalLocationCounts: MonthCountStat[] = [];
    inOutCounts: MonthCountStat[] = [];
    userCounts: MonthCountStat[] = [];
    terminalCounts: MonthCountStat[] = [];
    companyCounts: MonthCountStat[] = [];
    createdAccountCounts: MonthCountStat[] = [];
    inactiveCounts: MonthCountStat[] = [];

    async load() {
        try {
            this.loading = true;
            this.terminalLocationCounts = await this.api.monthCountStat(Routes.statsLocationCountMonths);
            this.inOutCounts = await this.api.monthCountStat(Routes.statsInOutCountMonths);
            this.userCounts = await this.api.monthCountStat(Routes.statsUserCountMonths);
            this.terminalCounts = await this.api.monthCountStat(Routes.statsTerminalCountMonths);
            this.companyCounts = await this.api.monthCountStat(Routes.statsCompanyCountMonths);
            this.createdAccountCounts = await this.api.monthCountStat(Routes.statsCompanyAccountCreatedCountMonths);
            this.inactiveCounts = await this.api.monthCountStat(Routes.statsCompanyInactivateMonths);
        } finally {
            this.loading = false;
        }
    }

    created() {
        this.requireCompanyRoles([companyroleid.super]);
        this.load();
    }

}
